// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeScreen_wrapper__3drUc","content":"ThreeScreen_content__3pzTi"};